import { putScrollbarSizeInCSSVariables } from './common/functions';
import fullpageInit from './components/fullpage-init';
import lottieAnimation from './components/lottie-animation';
import splideInit from './components/splide-init';
import { $ } from './common/variables';

// window.addEventListener('DOMContentLoaded', (event) => {
/*
 * Feature code example
 * */
$(document).ready(function () {
  putScrollbarSizeInCSSVariables();
  splideInit();
  fullpageInit();
  lottieAnimation();
});
// });
